var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M 118.516 34.495 L 397.66 238.484 L 221.799 238.484 L 182.57 238.484 L 208.757 267.693 L 412.087 494.484 L 118.516 494.484 L 118.516 34.495 M 101 0 L 101 512 L 451.316 512 L 221.799 256 L 451.316 256 L 101 0 Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FF4B55"
    },
    points: "118.516 34.495 397.66 238.484 221.799 238.484 182.57 238.484 208.757 267.692 412.087 494.484 118.516 494.484 118.516 34.495"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 101, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M102.79,317.661l10.786,22.258l20.47-13.883c0.903-0.613,2.115,0.087,2.036,1.176l-1.788,24.669   l24.669-1.788c1.089-0.079,1.788,1.133,1.176,2.036l-13.883,20.47l22.258,10.786c0.982,0.476,0.982,1.875,0,2.351l-22.258,10.786   l13.883,20.47c0.613,0.903-0.087,2.115-1.176,2.036l-24.669-1.788l1.788,24.669c0.079,1.089-1.133,1.788-2.036,1.176l-20.47-13.883   L102.79,451.46c-0.476,0.982-1.875,0.982-2.351,0l-10.786-22.258l-20.47,13.883c-0.903,0.613-2.115-0.087-2.036-1.176l1.788-24.669   l-24.669,1.788c-1.089,0.079-1.788-1.133-1.176-2.036l13.883-20.47l-22.258-10.786c-0.982-0.476-0.982-1.875,0-2.351l22.258-10.786   l-13.883-20.47c-0.613-0.903,0.087-2.115,1.176-2.036l24.669,1.788l-1.788-24.669c-0.079-1.089,1.133-1.788,2.036-1.176   l20.47,13.883l10.786-22.258C100.914,316.678,102.314,316.678,102.79,317.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M130.795,188.935l-9.365-6.397l8.244-8.64l-11.748-2.143l4.018-11.244l-11.604,2.82l-0.904-11.906   l-9.453,7.295l-5.669-10.51l-5.669,10.51l-9.453-7.295l-0.904,11.906l-11.604-2.82l4.018,11.244l-11.748,2.143l8.244,8.64   l-9.365,6.397c-11.815-5.517-22.203-13.576-30.379-23.546c5.492,31.993,33.296,56.366,66.858,56.366s61.367-24.372,66.858-56.366   C152.998,175.359,142.61,183.419,130.795,188.935z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/np.da76b29873b88bdd663adbe3b6281b20.svg";
export { ForwardRef as ReactComponent };